import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'recruitment_steps'

export const requests = {
  delete: async (id: string) => {
    return await axiosForGigbaseBiz.delete<DataResponse>(mergeURL(resource, id))
  },
}
